module.exports = __webpack_public_path__ + "img/tutorial.54fd9ede.svg";